export const NAME = "account";
export const INITIAL_STATE = {};

export const SET_USER = `${NAME}/SET_USER`;
